import styled from '@emotion/styled'
import { CalendarToday } from '@mui/icons-material'

export const CalendarDate = styled(CalendarToday)(() => ({
  marginRight: '10px'
}))
